import "./ParticipantOrderDisplay.css";
import { CustomerSale } from "../../../Interfaces/Dashboards";

interface ParticipantOrderDisplayProps {
  customerSales: CustomerSale[] | null,
}

const ParticipantOrderDisplay: React.FC<ParticipantOrderDisplayProps> = ({
  customerSales
}) => {
  return (
    <div className="participant-dashboard-customer-orders-container">
      <table className="participant-dashboard-customer-orders-table">
        <thead className="participant-dashboard-customer-orders-thead">
          <tr>
            <th className="participant-dashboard-customer-orders-th">
              Customer Name
            </th>
            <th className="participant-dashboard-customer-orders-th">
              Amt of Items
            </th>
            <th className="participant-dashboard-customer-orders-th">
              $ Amt Bought
            </th>
          </tr>
        </thead>
      </table>

      <div className="participant-dashboard-customer-orders-scrollable">
        <table className="participant-dashboard-customer-orders-table">
          <tbody className="participant-dashboard-customer-orders-tbody">
            {customerSales?.map((order, index) => (
              <tr
                className="participant-dashboard-customer-orders-tr"
                key={index}
              >
                <td
                  className="participant-dashboard-customer-orders-td"
                  data-label="Customer Name"
                >
                  {order.customer_name}
                </td>
                <td
                  className="participant-dashboard-customer-orders-td"
                  data-label="Amt of Items"
                >
                  {order.amt_items_sold}
                </td>
                <td
                  className="participant-dashboard-customer-orders-td"
                  data-label="$ Amt Bought"
                >
                  ${order.amt_bought.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ParticipantOrderDisplay;
